export const bonuses = [
  {
    number: 1,
    image: 'https://cdn.magicpatterns.com/uploads/upSjtMQn3F6PcT37YqRJvw/BONUS_1_NURSING-EN.png',
    title: 'Critical Care Nursing Quick-Reference Cards',
    value: '$17',
    tagline: 'Review essential concepts in a concise visual format.',
    intro:
      'I created these educational reference cards to help you revisit selected critical care concepts without having to navigate through an entire volume.',
    items: [
      'Critical care terminology cards.',
      'Hemodynamic parameter summaries.',
      'Respiratory monitoring concept cards.',
      'Neurological assessment terminology.',
      'Laboratory concept summaries.',
      'Important definitions and abbreviations.',
      'Interpretation considerations.',
      'Organized visual reference layouts.',
    ],
    why: 'Keep essential study concepts organized in a concise format that complements the six main volumes.',
    note: '',
  },
  {
    number: 2,
    image: 'https://cdn.magicpatterns.com/uploads/nH48ubPoEv5CBzwxU6uuoi/BONUS_2_NURSING-EN.png',
    title: 'The 10-Minute Critical Care Study Review',
    value: '$12',
    tagline: 'Make your study sessions more structured.',
    intro:
      'Sometimes you don’t need another long chapter. You need a clear way to organize a focused review session. This resource provides a repeatable structure for reviewing a critical care topic in a short study period.',
    items: [
      'Topic selection worksheet.',
      'Key concept review prompts.',
      'Monitoring terminology questions.',
      'Assessment concept checkpoints.',
      'Knowledge review questions.',
      'Personal study notes template.',
      'Follow-up learning checklist.',
    ],
    why: 'Use a consistent format to review what you’ve learned and identify the concepts you want to revisit.',
    note: 'The ten-minute format refers to an educational study session, not a complete patient assessment.',
  },
  {
    number: 3,
    image: 'https://cdn.magicpatterns.com/uploads/8sdypgUFpRpekcXe3Y9DDc/BONUS_3_NURSING-EN.png',
    title: 'The Critical Care Interpretation Mistakes Library',
    value: '$17',
    tagline: 'Recognize common misconceptions when studying critical care concepts.',
    intro:
      'I designed this resource to help you review common conceptual pitfalls and understand why context matters when interpreting monitoring information.',
    items: [
      'Examples of interpreting isolated measurements without context.',
      'Common misconceptions about hemodynamic parameters.',
      'Confusion between oxygenation and ventilation.',
      'Laboratory interpretation pitfalls.',
      'Measurement variability considerations.',
      'Examples involving conflicting findings.',
      'Questions about uncertainty and missing information.',
      'Guided educational reflection exercises.',
    ],
    why: 'Develop a more careful approach to reviewing clinical concepts and recognizing the limitations of individual findings.',
    note: '',
  },
  {
    number: 4,
    image: 'https://cdn.magicpatterns.com/uploads/tHHBuG4MW9Uvbtn8Gg8Y35/BONUS_4_NURSING-EN.png',
    title: 'Critical Care Clinical Case Practice Pack',
    value: '$17',
    tagline: 'Practice organizing clinical information through simulated cases.',
    intro: 'This additional collection gives you more opportunities to study the concepts covered in Volume VI.',
    items: [
      'Simulated patient presentation summaries.',
      'Selected monitoring information.',
      'Cardiovascular assessment scenarios.',
      'Respiratory assessment exercises.',
      'Laboratory interpretation questions.',
      'Cases involving multiple findings.',
      'Guided reasoning worksheets.',
      'Suggested educational explanations.',
    ],
    why: 'Complement the main casebook with additional opportunities to organize clinical information and explain your reasoning.',
    note: '',
  },
  {
    number: 5,
    image: 'https://cdn.magicpatterns.com/uploads/9zyHtQ64CCBCN3UAshzZkW/BONUS_5_NURSING-EN.png',
    title: 'The Critical Care Nursing Assessment Checklist Collection',
    value: '$12',
    tagline: 'Organize your educational review with structured checklists.',
    intro:
      'I included this collection to help you review selected critical care assessment topics in a consistent format.',
    items: [
      'Cardiovascular assessment study checklist.',
      'Respiratory assessment review checklist.',
      'Neurological assessment study checklist.',
      'Monitoring terminology review.',
      'Laboratory concept review checklist.',
      'Documentation study prompts.',
      'Clinical communication review questions.',
      'Personal learning-gap checklist.',
    ],
    why: 'Use structured prompts to review your educational material and identify topics that need further study.',
    note: 'These checklists are educational references, not approved bedside protocols.',
  },
];
